"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgThoughtFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M13.976 4.02a3.953 3.953 0 013.953 3.953 3.953 3.953 0 011.949 7.393 3.954 3.954 0 01-6.7 2.34 4.942 4.942 0 01-7.685-1.828 3.459 3.459 0 01-.41-6.882v-.035a2.965 2.965 0 015.09-2.067 3.955 3.955 0 013.803-2.874zm-6.628 8.605a.988.988 0 101.398-1.398.988.988 0 00-1.398 1.398zm3.953 0a.988.988 0 101.398-1.398.988.988 0 00-1.398 1.398zm3.953 0a.988.988 0 101.398-1.398.988.988 0 00-1.398 1.398z' }))); };
exports.default = SvgThoughtFilled;
//# sourceMappingURL=ThoughtFilled.js.map